const SimplePayCardRegistrationTerms = () => (
  <>
    <h3 className="text-2xl font-bold mb-4">Kártyaregisztrációs nyilatkozat</h3>
    <p className="my-2">
      Az ismétlődő bankkártyás fizetés (továbbiakban: „Ismétlődő fizetés”) egy, a
      SimplePay által biztosított bankkártya elfogadáshoz tartozó funkció, mely azt
      jelenti, hogy a Vásárló által a regisztrációs tranzakció során megadott
      bankkártyaadatokkal a jövőben újabb fizetéseket lehet kezdeményezni a
      bankkártyaadatok újbóli megadása nélkül. Az Ismétlődő fizetés igénybevételéhez jelen
      nyilatkozat elfogadásával Ön hozzájárul, hogy a sikeres regisztrációs tranzakciót
      követően jelen webshopban (
      <a
        href="https://app.arvaltozas.hu"
        target="_blank"
        rel="noreferrer"
        className="text-lightBlue-100"
      >
        https://app.arvaltozas.hu
      </a>
      ) kezdeményezett későbbi fizetések a bankkártyaadatok újbóli megadása és az Ön
      tranzakciónként hozzájárulása nélkül a Kereskedő által kezdeményezve történjenek.
    </p>
    <p className="my-2">
      Figyelem: a bankkártyaadatok kezelése a kártyatársasági szabályoknak megfelelően
      történik. A bankkártyaadatokhoz sem a Kereskedő, sem a SimplePay nem fér hozzá. A
      Kereskedő által tévesen vagy jogtalanul kezdeményezett ismétlődő fizetéses
      tranzakciókért közvetlenül a Kereskedő felel, Kereskedő fizetési szolgáltatójával
      (SimplePay) szemben bármilyen igényérvényesítés kizárt. Jelen tájékoztatót
      átolvastam, annak tartalmát tudomásul veszem és elfogadom.
    </p>
  </>
);

export default SimplePayCardRegistrationTerms;
